/**
 * Gemeinsame Helfer für Custom-Forms:
 * - E-Mail-Validierung
 * - Honeypot-Check
 * - UTM- / Cookie-Felder befüllen
 *
 * Wir arbeiten defensiv: läuft automatisch auf Forms mit data-custom-form,
 * stört bestehende Submit-Handler nicht, blockiert aber Bots/invalid E-Mails.
 */
(function () {
  "use strict";

  // --- Utilities ----------------------------------------------------------
  function getCookie(name) {
    var value = "; " + document.cookie;
    var parts = value.split("; " + name + "=");
    if (parts.length === 2) return parts.pop().split(";").shift();
    return null;
  }

  function getUtmParams() {
    var urlParams = new URLSearchParams(window.location.search);
    var utmParams = {};
    var utmKeys = [
      "utm_id",
      "utm_source",
      "utm_medium",
      "utm_campaign",
      "utm_content",
      "utm_term",
    ];

    utmKeys.forEach(function (key) {
      var value = urlParams.get(key);
      if (value) utmParams[key] = value;
    });

    return utmParams;
  }

  function setValueByIdPrefix(prefix, value) {
    var nodes = document.querySelectorAll('[id^="' + prefix + '"]');
    nodes.forEach(function (el) {
      el.value = value || "";
    });
  }

  // --- UTM/Cookie Füllung -------------------------------------------------
  function fillTrackingFields() {
    var sessionUtmCookie = getCookie("session_utms");
    var sessionUtms = {};
    if (sessionUtmCookie) {
      try {
        sessionUtms = JSON.parse(sessionUtmCookie);
      } catch (e) {
        sessionUtms = {};
      }
    }

    var currentUtms = getUtmParams();
    var utmSource = currentUtms.utm_source || sessionUtms.utm_source || "";
    var utmMedium = currentUtms.utm_medium || sessionUtms.utm_medium || "";
    var utmCampaign =
      currentUtms.utm_campaign || sessionUtms.utm_campaign || "";
    var utmTerm = currentUtms.utm_term || sessionUtms.utm_term || "";
    var utmContent = currentUtms.utm_content || sessionUtms.utm_content || "";

    var fbp = getCookie("_fbp") || "";
    var fbc = getCookie("_fbc") || "";
    var gclAu = getCookie("_gcl_au") || "";
    var gclAw = getCookie("_gcl_aw") || "";
    var ga = getCookie("_ga") || "";

    setValueByIdPrefix("utm_source", utmSource);
    setValueByIdPrefix("utm_medium", utmMedium);
    setValueByIdPrefix("utm_campaign", utmCampaign);
    setValueByIdPrefix("utm_term", utmTerm);
    setValueByIdPrefix("utm_content", utmContent);
    setValueByIdPrefix("_fbp", fbp);
    setValueByIdPrefix("_fbc", fbc);
    setValueByIdPrefix("_gcl_au", gclAu);
    setValueByIdPrefix("_gcl_aw", gclAw);
    setValueByIdPrefix("_ga", ga);
  }

  // --- E-Mail Validierung -------------------------------------------------
  function validateEmail(email) {
    if (!email || email.trim() === "") {
      return { valid: false, message: "Bitte gib eine E-Mail-Adresse ein." };
    }
    var emailRegex =
      /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/;
    if (!emailRegex.test(email.trim())) {
      return {
        valid: false,
        message:
          "Bitte gib eine gültige E-Mail-Adresse ein (z.B. name@beispiel.de).",
      };
    }
    var trimmedEmail = email.trim();
    if (trimmedEmail.length > 254) {
      return { valid: false, message: "Die E-Mail-Adresse ist zu lang." };
    }
    var parts = trimmedEmail.split("@");
    if (parts[0].length > 64) {
      return { valid: false, message: "Der Teil vor dem @ ist zu lang." };
    }
    return { valid: true, message: "" };
  }

  function setupEmailValidation(form) {
    var emailInput = form.querySelector('input[type="email"]');
    if (!emailInput) return;

    var describedBy = emailInput.getAttribute("aria-describedby");
    var errorEl =
      (describedBy && document.getElementById(describedBy)) ||
      form.querySelector(".form-error-message") ||
      form.querySelector(".signup-testversion__error");

    function showEmailError(message) {
      if (!errorEl) {
        errorEl = document.createElement("span");
        errorEl.className = "form-error-message";
        emailInput.insertAdjacentElement("afterend", errorEl);
      }
      emailInput.classList.add("error");
      emailInput.setAttribute("aria-invalid", "true");
      errorEl.textContent = message;
      errorEl.classList.add("show");
    }

    function hideEmailError() {
      emailInput.classList.remove("error");
      emailInput.setAttribute("aria-invalid", "false");
      if (errorEl) {
        errorEl.textContent = "";
        errorEl.classList.remove("show");
      }
    }

    emailInput.addEventListener("blur", function () {
      var validation = validateEmail(this.value);
      if (!validation.valid) showEmailError(validation.message);
      else hideEmailError();
    });

    emailInput.addEventListener("input", function () {
      if (this.classList.contains("error")) {
        var validation = validateEmail(this.value);
        if (validation.valid) hideEmailError();
      }
    });

    return {
      check: function () {
        var result = validateEmail(emailInput.value);
        if (!result.valid) {
          showEmailError(result.message);
          emailInput.focus({ preventScroll: false });
          emailInput.scrollIntoView({ behavior: "smooth", block: "center" });
        }
        return result.valid;
      },
    };
  }

  // --- GA Session ID abrufen ---------------------------------------------
  function fillGaSessionId(form) {
    var gaSessionIdField =
      form.querySelector('input[name="ga_session_id"]') ||
      form.querySelector('[id="ga_session_id"]');
    
    if (!gaSessionIdField) return;
    
    // Prüfe ob gtag verfügbar ist
    if (typeof gtag === "undefined") return;
    
    try {
      gtag("get", "G-94FQ304NK1", "session_id", function (session_id) {
        if (session_id && gaSessionIdField) {
          gaSessionIdField.value = session_id;
        }
      });
    } catch (error) {
      console.warn("Fehler beim Abrufen der GA Session ID:", error);
    }
  }

  // --- Honeypot & Submit Guard -------------------------------------------
  function setupHoneypotAndGuards(form) {
    var emailValidator = setupEmailValidation(form);
    var honeypot =
      form.querySelector('input[name="website"]') ||
      form.querySelector('[id^="website"]');

    // Verwende capture phase, damit dieser Handler vor anderen ausgeführt wird
    form.addEventListener(
      "submit",
      function (e) {
        // Tracking-Felder vor Submit aktualisieren (Cookies & session_utms)
        fillTrackingFields();
        
        // GA Session ID abrufen (falls Feld vorhanden)
        fillGaSessionId(form);

        // Honeypot
        if (honeypot && honeypot.value) {
          e.preventDefault();
          e.stopPropagation();
          return false;
        }

        // E-Mail Validation
        if (emailValidator && !emailValidator.check()) {
          e.preventDefault();
          e.stopPropagation();
          return false;
        }
      },
      true
    ); // capture phase
  }

  // --- Init --------------------------------------------------------------
  function initCustomForms(root) {
    var scope = root || document;
    var forms = scope.querySelectorAll("form[data-custom-form]");
    if (!forms.length) return;
    fillTrackingFields();
    forms.forEach(setupHoneypotAndGuards);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initCustomForms(document);
    });
  } else {
    initCustomForms(document);
  }

  // Für Theme-Editor / dynamische Sektionen
  document.addEventListener("shopify:section:load", function (event) {
    initCustomForms(event.target || event.detail?.target);
  });
})();
